import { Configurations } from '../../../models';
import {
  getPartnerKey,
  getWhitelabelDomain,
  getWhitelabelLogo,
  getWhitelabelName,
} from '../../../utils';

type State = Pick<
  Configurations,
  | 'widgetName'
  | 'partnerKey'
  | 'whitelabelDomain'
  | 'redirect'
  | 'whitelabelLogo'
  | 'isWhitelabel'
  | 'whitelabelName'
>;

/**
 * @desc конфиг контекста по умолчанию
 * */
export const createConstructorInitialConfig = (): State => {
  return {
    widgetName: undefined,
    partnerKey: getPartnerKey(),
    whitelabelDomain: getWhitelabelDomain(),
    whitelabelName: getWhitelabelName(),
    whitelabelLogo: getWhitelabelLogo(),
    redirect: '_blank',
    isWhitelabel: getWhitelabelName() !== 'LT',
  };
};
